import { render, staticRenderFns } from "./SirenSearchBar.vue?vue&type=template&id=287136fd&scoped=true&"
import script from "./SirenSearchBar.vue?vue&type=script&lang=js&"
export * from "./SirenSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SirenSearchBar.vue?vue&type=style&index=0&id=287136fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287136fd",
  null
  
)

export default component.exports